import React from "react";

const ScenarioThumbnailNav = ({
  quizzes,
  currentIndex,
  userAnswers,
  showUnansweredHighlights,
  setCurrentIndex,
  setSelectedOptionId,
}) => {
  return (
    <div className="thumbnail-navigation-wrapper">
      <div className="thumbnail-navigation">
        {quizzes.map((q, idx) => (
          <div
            key={idx}
            className={`thumbnail-nav-item ${
              idx === currentIndex ? "active" : ""
            } ${userAnswers[idx] ? "selected-answer" : ""} ${
              showUnansweredHighlights && !userAnswers[idx] ? "unanswered" : ""
            }`}
            onClick={() => {
              setCurrentIndex(idx);
              setSelectedOptionId(
                userAnswers[idx]?.selectedOption?.option_id || null
              );
            }}
          >
            <div className="quiz-thumbnail-number">#{idx + 1}</div>
            <img
              src={q.image_url}
              alt={q.title}
              className="thumbnail-img-small"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScenarioThumbnailNav;
